export default __webpack_public_path__ + "static/media/Solution_BG_Large.10434f04.png";